import { useState, ReactElement } from 'react';
import * as React from 'react';

import { CalciteButton, CalciteInput } from '@esri/calcite-components-react';

import { isValidUrl } from '../../util/urlUtils';

interface Props {
  onSubmitSearch: (searchQuery: SearchParams) => void;
  placeholder: string;
  initialValue?: string;
  icon?: string;
}

function ItemSearch({
  onSubmitSearch,
  placeholder,
  initialValue,
  icon = 'search',
}: Props): ReactElement<Props> {
  const [searchInput, setSearchInput] = useState(initialValue ?? '');

  React.useEffect(() => {
    if (initialValue) setSearchInput(initialValue);
  }, [initialValue]);

  const submitSearch = () => {
    const searchData: SearchParams = {};
    if (searchInput && isValidUrl(searchInput)) {
      const url = new URL(searchInput);
      searchData.url = `${url.protocol}//${url.host}${url.pathname}`;
    } else {
      searchData.title = searchInput;
    }
    onSubmitSearch(searchData);
  };

  return (
    <CalciteInput
      type="text"
      onCalciteInputInput={(e) => setSearchInput(e.target.value)}
      onKeyPress={(e) => {
        if (e.key === 'Enter') submitSearch();
      }}
      placeholder={placeholder}
      value={searchInput}
    >
      <CalciteButton
        slot="action"
        iconStart={icon}
        alignment="start"
        onClick={() => {
          submitSearch();
        }}
      />
    </CalciteInput>
  );
}

export default ItemSearch;
